import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    siteEnter: Date,
    inStory: false,
    navigationStatus: 'home',
    storySequence: 0,
    loaded: false
  },
  mutations: {
    storyStatus(state) {
      state.inStory = !state.inStory;
    },
    changeStory(state,payload) {
      state.storySequence = payload;
    },
    navigationStatus(state,payload) {
      state.navigationStatus = payload;
    }
  },
  actions: {
  },
  modules: {
  },
  strict: false
})
